var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.promoOpen)?_c('section',{class:{
    'promo-code-banner': true,
    pink: true,
    'allow-close': _vm.allowClose,
  }},[(_vm.allowClose)?_c('button',{staticClass:"close",on:{"click":_vm.togglePromo}},[_c('img',{attrs:{"src":require("../assets/close_x.svg"),"width":"11","height":"11","alt":"Close promo"}})]):_vm._e(),_c('h2',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.promoMessage)}}),_vm._v("  "),_c('span',{staticClass:"code"},[_vm._v("LOVE")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }